
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/category/[id]/[slug]",
      function () {
        return require("private-next-pages/blogs/category/[id]/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/category/[id]/[slug]"])
      });
    }
  